import type { FaireProductEntity } from "../../entity_types/product";

export const p_gt3k2pwpqm: FaireProductEntity = {
  token: "p_gt3k2pwpqm",
  type: "product",
  name: "Dreamstate Mushroom + Functional Powder for Deep Sleep",
  brandToken: "b_qh273szwef",
  brandName: "Microjoy",
  imageUrl:
    "https://cdn.faire.com/fastly/a54a77d99258629b1280ed0c07f5a921c8852c1e71594cbcfda2ad044b6db12a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b083b462c07483d19ecc19c5b06576fd7edf2e1d842e859b2dfc44791fbfd11.jpeg",
    "https://cdn.faire.com/fastly/ee782e378fd7d4d21229a4372a57ce8fe1f0d9346b13bb7fdc80080309055e52.png",
    "https://cdn.faire.com/fastly/e1a9e77adfec6cb4e8309586b4f4e6b5caef5b1a35cd8ecd8a9b037c1ed74c7e.jpeg",
    "https://cdn.faire.com/fastly/b187ee6b399a72a42d44a77348207e98e61153f4811a643f836781899bd41fe5.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Dreamstate Ultra Potent Powder  \nFOR SLEEP\nReishi + L-Tryptophan + L-Theanine + Magnesium\n\nSlow down, soothe your brain and redefine your waking life with the foundation of magically good sleep. This powerful relaxation formula of Reishi mushrooms, L-Trytophan, L-Theanine and Magnesium will support you in your quest for rest and restorative slumber.\n\nMicrojoy's Ultra Potent Powders are 100% sugar-free, vegan, additive-free and highly potent, so every wellness regimen can be turned into a ritual. At only 1/4 tsp. per serving, our product incorporates seamlessly into  beverages with little to no taste or texture, so beverages and baked goods will never taste chalky or dirty. In addition, each serving is affordable, making functional health accessible. \n\nAll products are non-GMO.\n\nSealed internally for freshness with a tamper proof external sticker. \nEach tube comes with a wooden spoon for dosing.\nShelf life is 18 months from production date. \n\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:52.348Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
